import { useState, useEffect } from "react";
import _ from 'lodash';

import { Button, Container, Card, CardContent, Typography, CardMedia, CardActions, Grid, Box } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

import CustomLayout from "views/CustomLayout";
import Carousel from "components/Carousel";
import Loader from 'components/Loader';
import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants, authRouteConstants } from 'constants/routeConstants';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GLOBAL_CURRENCY } from "constants/appConstants";
import ProductList from "./ProductList";
import ProductCard from "./ProductCard";
import { isMobile } from "react-device-detect";
import { updateUserDetail } from "utils/auth";
import { getAccessToken } from "utils";
import currency from "currency.js";
import { useStore } from "utils/OfflineContext";
import { Carousel as BannerCourousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import BannerCarousel from "./BannerCarousel";

let formatCurrency = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: GLOBAL_CURRENCY.code,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2
});
function formatCurrencyNew(value, currencySymbol = '$', precision = 2) {
  return currency(value, {
    symbol: currencySymbol,
    precision: precision,
    separator: ',',
    decimal: '.',
  }).format();
}

const DetailCard = ({ product }) => {
    const webDetails = useSelector(state => state.webDetails);
    const { websiteInfo } = webDetails;
    var navigate = useNavigate();
    const variant=product?.variants && product?.variants[0]
    console.log("info", variant)
    return (
        <div className="slider-card">
            <Card className="content-card">
                <CardMedia
                    sx={{ height: '200px', p: 2 }}
                    // sx={{   height: '375px' }}
                    title={variant?.name}
                >
                    <img src={variant?.images[0]?.image||variant?.images[0]?.image_url} />
                </CardMedia>
                <CardContent align="left" sx={{ marginTop: '0.5rem' }}>
                    <Typography
                        sx={{
                            display: { xs: "none", sm: "none", md: "none", lg: "none", xl: "flex" },
                        }}
                        gutterBottom component="span">
                        {_.truncate(_.trim(product.name), { length: 25 })}
                    </Typography>
                    <Typography
                        sx={{
                            display: { xs: "none", sm: "none", md: "none", lg: "flex", xl: "none" },
                            fontSize: '0.8rem !important',
                            minHeight: "50px"
                        }}
                        gutterBottom component="span">
                        {_.truncate(_.trim(product.name), { length: 30 })}
                    </Typography>
                    <Typography
                        sx={{
                            display: { xs: "none", sm: "none", md: "flex", lg: "none", xl: "none" },
                            fontSize: '1rem'
                        }}
                        gutterBottom component="span">
                        {_.truncate(_.trim(product.name), { length: 28 })}
                    </Typography>
                    <Typography
                        sx={{
                            display: { xs: "none", sm: "flex", md: "none", lg: "none", xl: "none" },
                            fontSize: '0.9rem'
                        }}
                        gutterBottom component="span">
                        {_.truncate(_.trim(product.name), { length: 22 })}
                    </Typography>
                    <Typography
                        sx={{
                            display: { xs: "flex", sm: "none", md: "none", lg: "none", xl: "none" }

                        }}
                        gutterBottom component="span">
                        {_.truncate(_.trim(product.name), { length: 25 })}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {/* <b>{GLOBAL_CURRENCY.symbol}{product?.price}</b> */}
                        <b>{formatCurrencyNew(variant?.price,websiteInfo?.currency_symbol,)}</b>
                    </Typography>
                </CardContent>
                <CardActions align="center">
                    {/* <Button size="small">Wishlist</Button> */}
                    <Button
                        color="success"
                        size="small"
                        onClick={() => {
                            navigate(`/product/${variant.id}`)
                        }}
                        variant="outlined">View</Button>
                </CardActions>
            </Card>
        </div>
    )
}

const DraftSection = ({ title, description, collection, explore, style = {} }) => {


    var navigate = useNavigate();
    return (
        collection.length > 0 ?
            <Container className="draft-section center" sx={style} >
                <div className="title-section center">
                    <span className="title">
                        {title}
                    </span>
                    <br />
                    {description && <p className="description" style={{textAlign:"left"}}>
                        {description}
                    </p>}
                </div>

                {explore && <Button
                    className="explore-btn"
                    variant="contained"
                    sx={{ mb: 2 }}
                    endIcon={<SendIcon />}
                    onClick={() => navigate("/products")}>
                    Explore
                </Button>}
                <div className="content-section">{
                    isMobile ?
                        <Grid container padding={"10px"} spacing={1}>
                            {collection.map(product => (
                                <Grid item xs={6} marginTop={1} key={product.id}>
                                    <ProductCard product={product} />
                                </Grid>
                            ))}
                        </Grid>
                        :
                        <Carousel>
                            {collection.map(product =>
                                <DetailCard
                                    product={product} />
                            )}
                        </Carousel>
                }
                </div>
            </Container>
            : ''
    )
}

const bgImage = require("../../assets/images/Webbie_default_banner.jpg");

const ResponsiveBgBox = ({ websiteInfo, ...props }) => (
    <>

        <Box
            sx={{
                display: { xs: 'none', sm: 'none', md: 'block' },

            }}
            className="banner-content">
            <CardMedia component={"img"}
                src={_.get(websiteInfo, 'banner', '')
                    ? `${_.get(websiteInfo, 'banner')}`
                    : `${bgImage}`

                }
                sx={{ width: "100%", minHeight: "30rem", maxHeight: "30rem", position: "absolute", objectFit: "fill" }}
            />
            {props.children}
        </Box>
        <Box
            sx={{
                display: { xs: 'block', sm: 'block', md: 'none' }
            }}
            className="banner-overlay"
        >
            <img className="banner-image" src={_.get(websiteInfo, 'banner')} />
            <div className="banner-detail">
                {props.children}
            </div>
        </Box>
    </>
)

const Landing = () => {
    const [loader, setLoader] = useState(false);
    const webDetails = useSelector(state => state.webDetails);
    const { websiteInfo } = webDetails;
    const { isStoreOn, toggleStore, setStoreOn, setStoreOff } = useStore();
    const [topCollection, setTopCollection] = useState([]);
    const [featureCollection, setFeatureCollection] = useState([]);
    const navigate = useNavigate();

    const normalizeProduct = (item) => {
        
         
    return    {
        ...item,
        id: item?.id || item?.id,
        name: item?.product_name || item?.name,
        product_image: (item?.images && item?.images[0]?.image) || item?.product_image
    }
    };


    function updateMetaDescription(newDescription) {
        const metaDescriptionTag = document.querySelector("meta[name='description']");
        if (metaDescriptionTag) {
            metaDescriptionTag.setAttribute('content', newDescription);
        } else {
            // If it doesn't exist, create it
            const newMetaTag = document.createElement('meta');
            newMetaTag.setAttribute('name', 'description');
            newMetaTag.setAttribute('content', newDescription);
            document.head.appendChild(newMetaTag); // Append it to the head
        }
    }

    // Function to update the favicon
    function updateFavicon(newFavicon) {
        const faviconLink = document.getElementById("favicon");
        if (faviconLink) {
            faviconLink.setAttribute('href', newFavicon);
        } else {
            const newFaviconLink = document.createElement('link');
            newFaviconLink.setAttribute('rel', 'icon');
            newFaviconLink.setAttribute('href', newFavicon);
            document.head.appendChild(newFaviconLink);
        }
    }

    // Function to update the apple-touch-icon
    function updateAppleTouchIcon(newAppleTouchIcon) {
        const appleTouchIconLink = document.getElementById("apple-touch-icon");
        if (appleTouchIconLink) {
            appleTouchIconLink.setAttribute('href', newAppleTouchIcon);
        } else {
            const newAppleTouchIconLink = document.createElement('link');
            newAppleTouchIconLink.setAttribute('rel', 'apple-touch-icon');
            newAppleTouchIconLink.setAttribute('href', newAppleTouchIcon);
            document.head.appendChild(newAppleTouchIconLink);
        }
    }

    // Function to update the manifest
    function updateManifest(newManifest) {
        const manifestLink = document.getElementById("manifest");
        if (manifestLink) {
            manifestLink.setAttribute('href', newManifest);
        } else {
            const newManifestLink = document.createElement('link');
            newManifestLink.setAttribute('rel', 'manifest');
            newManifestLink.setAttribute('href', newManifest);
            document.head.appendChild(newManifestLink);
        }
    }

     const getUserDetails = async (category) => {
         let token = getAccessToken();
         if(!token) return
        setLoader(true)
        let res = await axiosInstance.get(APIRouteConstants.AUTH.ME);
        let { data } = res;
    
        console.log("user", data)
        if (data && !_.isEmpty(data?.data)) {
          localStorage.setItem("u_user_data", JSON.stringify(data?.data))
          updateUserDetail(data.data)
        }
        setLoader(false)
      }


    useEffect(() => {
        localStorage.removeItem("vouchercode")
        const userData= localStorage.getItem("u_user_data")
        if (webDetails && webDetails?.websiteInfo?.store_name === "The Vet Store") {
            document.title = "The Vet Store"
            updateMetaDescription("The Vet Store")
            updateFavicon("/favicon1.ico"); // Fallback to default favicon
            updateAppleTouchIcon("/vetstore-512x512.png"); // Fallback to default apple-touch-icon
            updateManifest("/manifestvet.json"); // Fallback to default manifest

        }
        console.log("webDetails", websiteInfo?.whatsapp_status)
        setStoreOff(websiteInfo?.whatsapp_status)
        if (webDetails && webDetails?.websiteInfo?.store_name) {
            document.title = `Digital ordering solution | ${webDetails?.websiteInfo?.store_name}`
            updateMetaDescription(`Digital ordering solution | ${webDetails?.websiteInfo?.store_name}`)
            updateFavicon("/favicon.ico"); // Fallback to default favicon
            updateAppleTouchIcon(webDetails?.websiteInfo?.banner ? webDetails?.websiteInfo?.banner : "/logo192.png"); // Fallback to default apple-touch-icon
            updateManifest("/manifest.json"); // Fallback to default manifest
        }
        
        if (window.location.hostname.includes("alora") && window.dataLayer && userData) {
            window.dataLayer.push({
                event: "email_tracking",
                userEmail: JSON.parse(userData)?.email,
            });
        }

    }, [webDetails])

    const getTopCollection = async () => {
        setLoader(true)
        let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.TOP_COLLECTION);
        let { data, response } = res;

        if (data) {
            const filteredDisabledCollection = data?.filter((item) => 
                item?.variants[0]?.is_disabled===false
            )
            console.log("topcollection", data?.filter((item) => 
                item?.variants[0]?.is_disabled ===false
            ))
            const normalized = Array.isArray(filteredDisabledCollection) ? filteredDisabledCollection.map(normalizeProduct) : [];
          
            setTopCollection(normalized)
        }
        setLoader(false)
    }

    const getFeatureCollection = async () => {
        setLoader(true)
        let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.FEATURE_COLLECTION);
        let { data, response } = res;

        if (data) {
            const filteredDisabledCollection = data?.filter((item) => 
                item?.variants[0]?.is_disabled===false
            )
            console.log("topcollection", data?.filter((item) => 
                item?.variants[0]?.is_disabled ===false
            ))
            const normalized = Array.isArray(filteredDisabledCollection) ? filteredDisabledCollection.map(normalizeProduct) : [];
            setFeatureCollection(normalized)
        }
        setLoader(false)
    }

    useEffect(() => {
        getTopCollection();
        getFeatureCollection();
        getUserDetails()
    }, []);

    return (
        <CustomLayout>
            <Loader open={loader} />
         <BannerCarousel websiteInfo={_.get(websiteInfo, "banner", [])} bgImage={bgImage} />

            <DraftSection
                explore={true}
                title="Top Collection"
                collection={topCollection}
                description="These top favorites have been flying off the shelves! Grab them now. Don't miss out on the trendiest and most sought-after products - shop today!"
            />
            <DraftSection
                explore={true}
                title="Featured"
                collection={featureCollection}
                style="background-color: rgba(0,0,0,0.1); margin-bottom: 3rem ;"
                description="Discover our curated collection of must-have products. Shop now and redefine your world with us."
            />
        </CustomLayout>
    );
};

export default Landing;
